module.exports = {
      id: "myvikatanbadge-usage",
      viewBox: "0 0 499.854 524.656",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#myvikatanbadge",
      toString: function () {
        return this.url;
      }
    }